var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-coupon"},[_c('nav-bar',{attrs:{"navBarTitle":"我的优惠券"}}),_c('coupon-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }